import { Info, TriangleAlert } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

function Link(props) {
  const navigate = useNavigate();

  return (
    <a
      href={props.link}
      target="_blank"
      rel="noopener noreferrer"
      className="flex flex-col items-center gap-3 p-4 rounded-2xl bg-gray-900 hover:bg-gray-800 transition-colors"
    >
      <div className={`${props.color || 'bg-gray-700'} rounded-lg overflow-clip bg-white`}>
        <img src={props.image} alt={props.label} className="size-8 object-cover"/>
      </div>
      <div class="flex flex-col items-center gap-1">
        <span className="text-sm font-medium">{props.label}</span>
        { props.info ?
          <span className="text-xs text-neutral-400"><Info className="inline size-3 text-white" /> {props.info}</span>
        : null }

        { props.warning ?
          <span className="text-xs text-yellow-600"><TriangleAlert className="inline size-3" /> {props.warning}</span>
        : null }
      </div>
    </a>
  );
}

export default Link;
